// src/services/socket.js
import { io } from 'socket.io-client';
import config from '../config';

const socket = io(config.baseUrl, {
    withCredentials: true,
    transports: ['websocket', 'polling']
});

export default socket;
